import { Typography } from '@mui/material';
import classNames from 'classnames';

import { useValidationTranslation } from '../../hooks';
import { Iconify } from '../Iconify';
import './ErrorMessage.scss';

export interface ErrorMessageProps {
  errors?: string | string[];
  withoutIcon?: boolean;
  className?: string;
}

export const ErrorMessage = ({
  className,
  errors,
  withoutIcon,
}: ErrorMessageProps) => {
  const { translate } = useValidationTranslation();
  if (!errors) {
    return null;
  }
  if (Array.isArray(errors)) {
    return (
      <ul className={classNames('Mfw-ErrorMessage', className)}>
        {errors.map((error, index) => (
          <li key={index}>
            {index === 0 ? (
              <div className="flex gap-2 items-center">
                {!withoutIcon && (
                  <Iconify icon="mdi:alert-circle" size="tiny" />
                )}
                <Typography className="pl-4" variant="body2">
                  {translate(error)}
                </Typography>
              </div>
            ) : (
              <Typography sx={{ marginLeft: 2.8 }} variant="body2">
                {translate(error)}
              </Typography>
            )}
          </li>
        ))}
      </ul>
    );
  }
  return (
    <div
      className={classNames(
        'Mfw-ErrorMessage',
        className,
        'flex gap-2 items-center',
      )}
    >
      {!withoutIcon && <Iconify icon="mdi:alert-circle" size="tiny" />}
      <Typography variant="body2" sx={{ pt: 1 }}>
        {translate(errors)}
      </Typography>
    </div>
  );
};
